/* STUDIYO – product page enhancements */
(function () {
  function init() {
    enhanceGallery();
    syncVariantImage();
    moveGiftBelowCart();
    cleanComparePrice();
    addReassurance();
    buildStickyAtc();
    suppressStickyDuringReview();
  }

  /* When a variant is selected, jump the gallery to that variant's image. */
  function syncVariantImage() {
    var viewport = document.querySelector('[data-product-gallery-viewport]');
    if (!viewport || !('MutationObserver' in window)) return;
    var mobile = window.matchMedia('(max-width: 768px)');

    function showSelected() {
      var sel = viewport.querySelector(
        '.product-gallery--viewport--figure[data-product-gallery-selected="true"]'
      );
      if (!sel) return;
      if (mobile.matches) {
        viewport.scrollTo({ left: sel.offsetLeft, behavior: 'smooth' });
      } else {
        sel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    var armed = false;
    setTimeout(function () { armed = true; }, 1200);

    var figs = viewport.querySelectorAll('.product-gallery--viewport--figure');
    var mo = new MutationObserver(function (muts) {
      if (!armed) return;
      for (var i = 0; i < muts.length; i++) {
        var tgt = muts[i].target;
        if (muts[i].attributeName === 'data-product-gallery-selected' &&
            tgt.getAttribute('data-product-gallery-selected') === 'true') {
          showSelected();
          break;
        }
      }
    });
    figs.forEach(function (f) {
      mo.observe(f, { attributes: true, attributeFilter: ['data-product-gallery-selected'] });
    });
  }

  /* Hide the sticky bar while an overlay is open (review form or cart drawer). */
  function suppressStickyDuringReview() {
    function reviewFormOpen() {
      var forms = document.querySelectorAll('.jdgm-form-wrapper, .jdgm-form, .jdgm-form-modal');
      for (var i = 0; i < forms.length; i++) {
        var f = forms[i];
        if (f.offsetParent !== null && f.getBoundingClientRect().height > 5) return true;
      }
      return false;
    }
    function cartDrawerOpen() {
      var vh = window.innerHeight, vw = window.innerWidth;
      var nodes = document.querySelectorAll(
        'aside, dialog, [role="dialog"], [data-cart-mini], [class*="cart"], ' +
        '[class*="drawer"], [class*="Drawer"], [class*="navidium"], [class*="nvd"], ' +
        '[id*="cart"], [id*="drawer"]'
      );
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.id === 'studiyo-sticky-atc') continue;
        var cs = getComputedStyle(el);
        if (cs.position !== 'fixed') continue;
        if (cs.display === 'none' || cs.visibility === 'hidden') continue;
        if (parseFloat(cs.opacity) < 0.5 || cs.pointerEvents === 'none') continue;
        var r = el.getBoundingClientRect();
        if (r.height < vh * 0.55 || r.width < 220) continue;
        if (r.left >= vw - 20 || r.right <= 20) continue;
        if (r.top >= vh - 20 || r.bottom <= 20) continue;
        return true;
      }
      return false;
    }
    function sync() {
      var bar = document.getElementById('studiyo-sticky-atc');
      if (bar) bar.classList.toggle('studiyo-suppressed', reviewFormOpen() || cartDrawerOpen());
    }
    var pending;
    function schedule() {
      if (pending) return;
      pending = setTimeout(function () { pending = null; sync(); }, 60);
    }
    document.addEventListener('click', schedule, true);
    if ('MutationObserver' in window) {
      new MutationObserver(schedule).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
  }

  function isGiftCard() {
    if (/gift-card/i.test(location.pathname)) return true;
    var p = window.featuredProduct;
    if (p && /gift\s*card/i.test((p.title || '') + ' ' + (p.type || ''))) return true;
    if (document.querySelector('[name*="recipient"], .recipient-form, [data-recipient-form]')) return true;
    return false;
  }

  /* Trust/reassurance line under the Add to Cart button (not on gift cards) */
  function addReassurance() {
    if (document.getElementById('studiyo-reassurance')) return;
    if (isGiftCard()) return;
    var form = document.querySelector('[data-product-form]');
    var atc = getAtc();
    var anchor = form || (atc && atc.parentElement);
    if (!anchor || !anchor.parentNode) return;
    var el = document.createElement('div');
    el.id = 'studiyo-reassurance';
    var tags = (window.featuredProduct && window.featuredProduct.tags) || [];
    if (typeof tags === 'string') { tags = tags.split(','); }
    var madeToOrder = tags.join(',').toLowerCase().indexOf('made-to-order') !== -1;
    el.innerHTML =
      '<span>Free U.S. shipping over $150</span>' +
      (madeToOrder ? '' : '<span class="sep">&middot;</span><span>15-day returns</span>') +
      '<span class="sep">&middot;</span>' +
      '<span>Ships from California</span>';
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
  }

  function isVisible(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    var r = el.getBoundingClientRect();
    return cs.display !== 'none' && cs.visibility !== 'hidden' &&
           r.width > 0 && r.height > 0 && !el.disabled;
  }

  function getAtc() {
    var sels = [
      '[data-product-form] .product-submit',
      '.product-submit',
      '[data-product-form] [name="add"]',
      '[name="add"]'
    ];
    for (var i = 0; i < sels.length; i++) {
      var els = document.querySelectorAll(sels[i]);
      for (var j = 0; j < els.length; j++) {
        if (isVisible(els[j])) return els[j];
      }
    }
    return document.querySelector('.product-submit') ||
           document.querySelector('[data-product-form] [name="add"]');
  }

  function triggerAddToCart() {
    var live = getAtc();
    if (live) {
      live.click();
      return;
    }
    var form = document.querySelector('[data-product-form]');
    if (form) {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }
  }

  /* Mobile swipe gallery: thumbnails act as dots */
  function enhanceGallery() {
    var mobile = window.matchMedia('(max-width: 768px)');
    var viewport = document.querySelector('[data-product-gallery-viewport]');
    if (!viewport) return;

    var figures = Array.prototype.slice.call(
      viewport.querySelectorAll('.product-gallery--viewport--figure')
    );
    var thumbs = Array.prototype.slice.call(
      document.querySelectorAll('[data-product-gallery-thumbnail]')
    );

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        if (!mobile.matches) return;
        var fig = figures[i];
        if (fig) viewport.scrollTo({ left: fig.offsetLeft, behavior: 'smooth' });
      });
    });

    var ticking = false;
    viewport.addEventListener('scroll', function () {
      if (!mobile.matches || ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var center = viewport.scrollLeft + viewport.clientWidth / 2;
        var activeIndex = 0;
        figures.forEach(function (fig, i) { if (fig.offsetLeft <= center) activeIndex = i; });
        thumbs.forEach(function (t, i) {
          t.setAttribute('data-product-gallery-selected', i === activeIndex ? 'true' : 'false');
        });
        ticking = false;
      });
    }, { passive: true });
  }

  /* Move the "Mark as a Gift" toggle below the Add to Cart button */
  function moveGiftBelowCart() {
    function move() {
      var gift = document.querySelector('.effectiveAppsWiggle');
      var atc = getAtc();
      if (!gift || !atc || !atc.parentElement) return;
      if (gift.compareDocumentPosition(atc) & Node.DOCUMENT_POSITION_FOLLOWING) {
        atc.parentElement.insertBefore(gift, atc.nextSibling);
      }
    }
    move();
    setTimeout(move, 600);
    setTimeout(move, 1500);
  }

  /* Hide the empty strikethrough price when the item isn't on sale */
  function cleanComparePrice() {
    function clean() {
      document.querySelectorAll('.product__price').forEach(function (pp) {
        var orig = pp.querySelector('s.original, .original');
        var last = pp.querySelector('.money--last');
        if (!orig) return;
        var ot = (orig.textContent || '').replace(/[^0-9]/g, '');
        var lt = last ? (last.textContent || '').replace(/[^0-9]/g, '') : '';
        orig.style.display = (!ot || ot === lt) ? 'none' : '';
      });
    }
    clean();
    var pc = document.querySelector('.product__price');
    if (pc && 'MutationObserver' in window) {
      new MutationObserver(clean).observe(pc, { childList: true, subtree: true, characterData: true });
    }
    setTimeout(clean, 800);
  }

  /* Sticky Add to Cart bar on mobile */
  function buildStickyAtc() {
    var atc = getAtc();
    if (!atc || document.getElementById('studiyo-sticky-atc')) return;

    var priceEl = document.querySelector('.product__price .money--last') ||
                  document.querySelector('.product__price');
    var titleEl = document.querySelector('.product__title');

    var bar = document.createElement('div');
    bar.id = 'studiyo-sticky-atc';

    var info = document.createElement('div');
    info.className = 'ssa-info';
    var t = document.createElement('span');
    t.className = 'ssa-title';
    t.textContent = titleEl ? (titleEl.textContent || '').split('|')[0].trim() : '';
    var pr = document.createElement('span');
    pr.className = 'ssa-price';
    pr.textContent = priceEl ? priceEl.textContent.trim() : '';
    info.appendChild(t);
    info.appendChild(pr);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ssa-btn';
    btn.textContent = 'Add to cart';
    try {
      var cs = getComputedStyle(atc);
      if (cs && cs.backgroundColor && cs.backgroundColor !== 'rgba(0, 0, 0, 0)') {
        btn.style.backgroundColor = cs.backgroundColor;
        btn.style.color = cs.color;
      }
    } catch (e) {}
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      triggerAddToCart();
    });

    bar.appendChild(info);
    bar.appendChild(btn);
    document.body.appendChild(bar);

    var pc = document.querySelector('.product__price');
    if (pc && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var p = document.querySelector('.product__price .money--last');
        if (p) pr.textContent = p.textContent.trim();
      }).observe(pc, { childList: true, subtree: true, characterData: true });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          bar.classList.toggle('is-visible', !en.isIntersecting);
        });
      }, { rootMargin: '0px 0px -10% 0px' }).observe(atc);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
